module.exports = __webpack_public_path__ + "img/icon-energy-fridge.e7470982.svg";